import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetAllPostsQuery } from "../../Services/APIs";
import Chatbot from "../Chatbot/Chatbot";
import ZapierChatbot from "../Chatbot/Chatbot_zapier";
import HeroBanner from "../HeroBanner/HeroBanner";
import IconText from "../IconText/IconText";
import ByrneNews from "../News/ByrneNews";
import EventsFilter from "../Events/EventsFilter";
import SidebarMenu from "../SidebarMenu/SidebarMenu";
import ByrneLinkedin from "../SocialMedia/ByrneLinkedin";

const Home = () => {
  let navigate = useNavigate();
  const [showQuickLinks, setShowQuickLinks] = useState(true);

  const toggleQuickLinks = () => {
    setShowQuickLinks(!showQuickLinks);
  };

  const { refetch: byrnePostsRefetch } = useGetAllPostsQuery();

  useEffect(() => {
    byrnePostsRefetch();
  }, [byrnePostsRefetch]);

  return (
    <div style={{ height: "100%" }}>
      <div>
        <IconText />
      </div>
      <div className="homePage">
        <Box className="content" style={{ marginRight: "30px", marginTop: "16px" }}>
          <Grid container spacing={2}>
            {/* Quick Links / Menu Container */}
            <Grid
              item
              xs={12}
              md={2}
              // md={sidebarOpen ? 2 : 0.5}
              style={{ padding: "0px" }}
            >
              <div className="documentPortalBox">
                <SidebarMenu />
              </div>
            </Grid>

            {/* Main Content Area */}
            {/* <Grid item xs={12} md={showQuickLinks ? 7 : 8}>
              <HeroBanner />
              <Grid container spacing={2} style={{ gap: "0px" }}>
                <Grid item xs={12} md={12} style={{ marginBottom: "22px" }}>
                  <ByrneNews />
                </Grid>
              </Grid>
            </Grid> */}
            <Grid container spacing={2} item xs={12} md={10}>
              <Grid
                item
                xs={12}
                // md={showQuickLinks ? 7 : 8}
                md={8}
              >
                <HeroBanner />
                <Grid container spacing={2} style={{ gap: "0px" }}>
                  <Grid item xs={12} md={12}>
                    <ByrneNews />
                  </Grid>
                  {/* <Grid item xs={12} md={5} style={{ marginBottom: "22px", marginTop: "16px"  }}>
                  
                  <SocialMediaLinkedin/>
                </Grid> */}
                </Grid>
              </Grid>

              {/* Sidebar */}
              <Grid
                item
                xs={12}
                // md={showQuickLinks ? 3 : 3.5}
                md={4}
              >
                {/* <Contact /> */}
                {/* <Events /> */}
                {/* EventsFilter moved to ByrnePosts position */}
                <EventsFilter
                  handleDateChange={function (date: Date | Date[]): void {
                    throw new Error("Function not implemented.");
                  }}
                  tileClassName={function (
                    date: any
                  ): "highlightedDate" | null {
                    throw new Error("Function not implemented.");
                  }}
                  selectedDate={null}
                  selectedEvents={[]}
                  isLoading={false}
                />
                {/* ByrneLinkedin moved to EventsFilter's previous position */}
                <ByrneLinkedin />
              </Grid>
            </Grid>

            {/* Chatbot */}
            {/* <Box display="flex" gap={5}>
                <Chatbot />
                <ZapierChatbot />
              </Box>  */}
            <Grid item xs={12} md={12}>
              <Chatbot />
              {/* <ZapierChatbot/> */}
            </Grid>
          </Grid>
        </Box>
      </div>
    </div>
  );
};

export default Home;
